module.exports = __webpack_public_path__ + "img/reactivite.c4ddaa60.png";